import { FaLinkedinIn } from 'react-icons/fa6';
import { BsBook } from 'react-icons/bs';

const PostMeta = ({ isEnglish, toggleLanguage }) => {
  const shareUrl = typeof window !== 'undefined' ? window.location.href : '';

  return (
    <div className='w-full grid grid-cols-1 md:grid-cols-3 items-center gap-4 text-neutral-7 text-content leading-normal my-8 md:my-14'>
      <p className='flex items-center gap-2'>
        <BsBook /> 17 Mei 2025
      </p>
      <p>{isEnglish ? '10 min read' : '10 Menit Membaca'} </p>

      {/* <div className='flex items-center gap-2 text-white'>
        <span className='text-neutral-7 mr-2'>Share:</span>
        <a
          // href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          //   shareUrl
          // )}`}
          // target='_blank'
          // rel='noopener noreferrer'
          className='bg-mainGreen-light p-1.5 rounded-full cursor-pointer'
        >
          <FaLinkedinIn />
        </a>
      </div> */}

      <p
        className=' text-mainGreen font-medium hover:font-bold hover:underline cursor-pointer'
        onClick={toggleLanguage}
      >
        {isEnglish ? 'Baca dalam Bahasa Indonesia' : 'Read in English'}
      </p>
    </div>
  );
};

export default PostMeta;
